/* Ayudate · Rechazar una solicitud de tutoría
   El "No puedo dar la clase" del panel del tutor (DashboardTutor.jsx) ya no
   es un window.confirm: abre esta ventana y pide el mensaje que el
   estudiante va a recibir por correo. La solicitud queda rechazada igual
   —eso no cambió—, lo que cambia es que del otro lado llega algo con lo que
   se puede hacer algo: por qué no se puede a esa hora, o a cuál sí.

   El texto de ayuda de acá es la mitad del asunto. Sin una sugerencia
   concreta, lo que se escribe en una caja titulada "motivo" son dos
   palabras ("no puedo", "ocupado") que dejan al estudiante exactamente
   donde estaba; con ella, lo normal es que proponga un horario, y ese
   horario es lo único que convierte un rechazo en una tutoría reagendada.

   Mismo reparto que CancelarSesion.jsx, del que copia la forma: este
   archivo arma el formulario y traduce los errores del servidor, y el panel
   se queda con la sesión viva y con mandar a /login si venció. */

import React, { useState } from "react";
import { Capa } from "./Capa";
import { ErrorApi } from "../api";

/* Espeja MENSAJE_RECHAZO_MIN/MAX de apps-script.gs: acá se avisa antes de
   mandar, pero el servidor lo vuelve a validar — nunca se confía del
   navegador. */
export const MENSAJE_MIN = 10;
export const MENSAJE_MAX = 300;

/* El servidor devuelve códigos, no frases (ver intentar() en apps-script.gs). */
const POR_CODIGO = {
  MENSAJE_CORTO: `Escriba al menos ${MENSAJE_MIN} caracteres.`,
  MENSAJE_LARGO: `El mensaje no puede pasar de ${MENSAJE_MAX} caracteres.`,
  YA_USADO: "Esta solicitud ya fue respondida — puede que la haya contestado desde el "
    + "correo. Cierre y recargue el panel para verla al día.",
  VENCIDO: "El plazo para responder esta solicitud ya venció. El equipo ya está avisado; "
    + "si todavía puede darla, escríbanos por WhatsApp.",
  NO_AUTORIZADO: "Esta solicitud no aparece como suya.",
  SOLICITUD_INVALIDA: "No encontramos esa solicitud. Recargue el panel y pruebe de nuevo.",
  ACCION_INVALIDA: "No pudimos procesar la respuesta. Recargue el panel y pruebe de nuevo.",
};

export function RechazarSolicitud({ resumen, onRechazar, onCerrar, onListo }) {
  const [mensaje, setMensaje] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState("");

  const limpio = mensaje.trim();
  const corto = limpio.length < MENSAJE_MIN;

  const enviar = async () => {
    if (corto || enviando) return;
    setEnviando(true); setError("");
    try {
      await onRechazar(limpio);
      onListo();
    } catch (err) {
      const codigo = err instanceof ErrorApi ? err.codigo : null;
      setError(POR_CODIGO[codigo] || err.message || "No pudimos enviar su respuesta.");
      setEnviando(false);
    }
  };

  return (
    <Capa onCerrar={onCerrar} etiqueta="Rechazar solicitud" confirmarSalida={limpio.length > 0}>
      <div className="mdl">
        <div className="mdl-h">
          <h3>No puedo dar esta clase</h3>
          <button className="x" aria-label="Cerrar" onClick={onCerrar}>×</button>
        </div>
        <div className="mdl-b">
          <p style={{ margin: "0 0 6px" }}>{resumen}</p>
          <p className="ayuda" style={{ margin: "0 0 16px" }}>
            Le mandamos su mensaje al estudiante junto con el aviso de que rechazó la
            solicitud, y lo invitamos a agendar de nuevo. La solicitud queda cerrada:
            para reservar, él tiene que enviarla otra vez desde la página.
          </p>

          {error && <div className="error" role="alert" style={{ marginBottom: 14 }}>{error}</div>}

          <label className="lb" htmlFor="mensaje-rechazo" style={{ marginTop: 0 }}>
            ¿Por qué no puede a esa hora?
          </label>
          <textarea id="mensaje-rechazo" className="in ta" rows={3} maxLength={MENSAJE_MAX}
            placeholder="Ej: ese día tengo laboratorio hasta las 7 p. m., pero el jueves a las 4 p. m. sí puedo."
            value={mensaje} onChange={(e) => setMensaje(e.target.value)} />
          <p className={`ayuda ${corto ? "mal" : ""}`} style={{ margin: "6px 0 6px" }}>
            {corto
              ? `${limpio.length} de ${MENSAJE_MIN} caracteres mínimo`
              : `${mensaje.length}/${MENSAJE_MAX}`}
          </p>
          <p className="ayuda" style={{ margin: "0 0 18px" }}>
            Si le sirve otro día u otra hora, propóngasela acá: es lo que le permite al
            estudiante volver a pedirla al horario que sí le calza, en vez de tener que
            buscar otro tutor.
          </p>

          <div className="fila-acciones">
            <button className="btn" onClick={onCerrar} disabled={enviando}>
              Mejor no
            </button>
            <button className="btn btn-danger" onClick={enviar} disabled={corto || enviando}>
              {enviando ? "Enviando…" : "Enviar y rechazar"}
            </button>
          </div>
        </div>
      </div>
    </Capa>
  );
}
